import { MAX_LAYER_NAME_LENGTH, type LayerRole } from "./layerTypes";

const ROLE_LABELS: Readonly<Record<LayerRole, string>> = {
  sketch: "Sketch",
  ink: "Ink",
  colour: "Colour",
  background: "Background",
  dialogue: "Dialogue",
  custom: "New Layer",
};

export function defaultLayerName(role: LayerRole): string {
  return ROLE_LABELS[role];
}

export function sanitizeLayerName(value: unknown): string {
  if (typeof value !== "string") return "";
  return value
    .normalize("NFKC")
    .replace(/[\p{Cc}\p{Cf}]/gu, "")
    .replace(/\s+/g, " ")
    .trim()
    .slice(0, MAX_LAYER_NAME_LENGTH)
    .trim();
}

export function uniqueLayerName(
  requested: unknown,
  existingNames: ReadonlyArray<string>,
  fallbackRole: LayerRole = "custom",
): string {
  const base = sanitizeLayerName(requested) || defaultLayerName(fallbackRole);
  const used = new Set(existingNames.map((name) => name.toLocaleLowerCase()));
  if (!used.has(base.toLocaleLowerCase())) return base;
  for (let suffix = 2; suffix < 10_000; suffix += 1) {
    const suffixText = ` ${suffix}`;
    const candidate = `${base.slice(0, MAX_LAYER_NAME_LENGTH - suffixText.length).trim()}${suffixText}`;
    if (!used.has(candidate.toLocaleLowerCase())) return candidate;
  }
  return `${base.slice(0, MAX_LAYER_NAME_LENGTH - 5).trim()} 9999`;
}
